import {formatDate} from '@/common/directives/formatDate.js';
import {modelSanitize} from '@simpleforyou/client-core';
import {Directive} from 'vue';

export const directives = [
  formatDate,
  modelSanitize,
] as { name: string, directive: Directive }[];
